import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import React from "react";
import { AiSearchContainer, FlexContainer } from "../style";
import {
  MahaloAiStarIcon,
  SmallFavouriteFilledIcon,
  SmallFavouriteIcon,
} from "../../../Common/assets/Icons";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import { addFavourites } from "../../../../Redux/actions/aiSearchAction";
import { setCurrentSearchId } from "../../../../Redux/reducers/aiSearchSlice";

const AiSearchContent = () => {
  const responseLoader = useAppSelector((state) => state.aiSearch.resultLoader);
  const favouriteLoader = useAppSelector(
    (state) => state.aiSearch.favouriteLoader
  );
  const aiSearchData = useAppSelector((state) => state.aiSearch.aiSearchData);

  const dispatch = useAppDispatch();

  const handleFavourite = (query: any) => {
    dispatch(addFavourites(query?.id, !query?.favourite));
  };

  const handleViewResults = (queryId: string) => {
    dispatch(setCurrentSearchId(queryId));
  };

  return (
    <Box sx={{ ...AiSearchContainer }}>
      {aiSearchData?.length === 0 ? (
        <Box sx={FlexContainer}>
          <Typography variant="body1" fontWeight="regular" color="gray">
            No search results. Enter a query to begin.
          </Typography>
        </Box>
      ) : (
        <Stack>
          {aiSearchData?.map((item: any, index: number) => {
            return (
              <Box key={item?.id}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      maxWidth: "60%",
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#F3F4F6",
                        width: "fit-content",
                        wordBreak: "break-word",
                        borderRadius: "20px",
                        p: "10px 20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight={"regular"}
                        color="text.primary"
                      >
                        {item?.userInput}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{ cursor: "pointer", width: "24px", height: "24px" }}
                    onClick={() => handleFavourite(item)}
                  >
                    {favouriteLoader !== item?.id ? (
                      item?.favourite ? (
                        <SmallFavouriteFilledIcon />
                      ) : (
                        <SmallFavouriteIcon />
                      )
                    ) : (
                      <CircularProgress size={18} />
                    )}
                  </Box>
                </Box>
                {item?.response && (
                  <Box
                    sx={{
                      mb: 4,
                    }}
                  >
                    <MahaloAiStarIcon />
                    <Box display="flex" gap={"4px"} alignItems={"center"}>
                      <Typography variant="body1" color="text.primary">
                        {item?.count} Results found.
                      </Typography>
                      <Typography
                        variant="body1"
                        fontWeight={"medium"}
                        sx={{
                          color: "#190DD7",
                          cursor: "pointer",
                        }}
                        onClick={() => handleViewResults(item?.id)}
                      >
                        View Results
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            );
          })}
          {responseLoader && (
            <Box
              sx={{
                mb: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={25} />
            </Box>
          )}
        </Stack>
      )}
    </Box>
  );
};

export default React.memo(AiSearchContent);
